module.exports = __webpack_public_path__ + "static/logo-chianticlassico-e078194a6933504f259a3adaf6a19755.svg";